var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSidebarMydetails = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.01016 6.91367H1.37129C0.854492 6.91367 0.432617 6.49355 0.432617 5.975V1.33613C0.432617 0.819336 0.852734 0.397461 1.37129 0.397461H6.01016C6.52695 0.397461 6.94883 0.817578 6.94883 1.33613V5.975C6.94883 6.4918 6.52695 6.91367 6.01016 6.91367ZM1.4873 5.85898H5.89414V1.45215H1.4873V5.85898ZM6.01016 15.6025H1.37129C0.854492 15.6025 0.432617 15.1824 0.432617 14.6639V10.025C0.432617 9.5082 0.852734 9.08633 1.37129 9.08633H6.01016C6.52695 9.08633 6.94883 9.50645 6.94883 10.025V14.6639C6.94883 15.1824 6.52695 15.6025 6.01016 15.6025ZM1.4873 14.5479H5.89414V10.141H1.4873V14.5479ZM8.02461 1.56113H15.5674V2.61582H8.02461V1.56113ZM8.02461 4.69531H12.899V5.75H8.02461V4.69531ZM8.02461 10.25H15.5674V11.3047H8.02461V10.25ZM8.02461 13.3842H12.899V14.4389H8.02461V13.3842Z",
    fill: "#557CA3"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSidebarMydetails, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sidebar-mydetails.ec9140a7.svg";
export { ForwardRef as ReactComponent };